module.exports = __webpack_public_path__ + "static/media/ReactConcentrationGameIcon.e3f127fa.png";